import { render, staticRenderFns } from "./EducationDetails.vue?vue&type=template&id=55674d43"
import script from "./EducationDetails.vue?vue&type=script&lang=js"
export * from "./EducationDetails.vue?vue&type=script&lang=js"
import style0 from "./EducationDetails.vue?vue&type=style&index=0&id=55674d43&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports